import { render } from "./SessionInventory.vue?vue&type=template&id=2b4bface&scoped=true"
import script from "./SessionInventory.vue?vue&type=script&lang=js"
export * from "./SessionInventory.vue?vue&type=script&lang=js"

import "./SessionInventory.vue?vue&type=style&index=0&id=2b4bface&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4bface"]])

export default __exports__